import React from 'react';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Container,
  Typography,
} from '@mui/material';
import { faq } from '../../utils/faq';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const theme = createTheme({
  components: {
    MuiAccordion: {
      styleOverrides: {
        root: {
          marginBottom: '1rem',
          boxShadow: 'none', // Remove default box shadow
          '&:before': {
            // Remove default border
            display: 'none',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        expandIcon: {
          // Style expand icon
          color: '#000',
        },
        content: {
          // Style summary content
          margin: '0',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        h6: {
          // Style question text
          fontWeight: 'bold',
        },
      },
    },
  },
});

export const FAQ = () => {
  const faqData = faq;
  return (
    <ThemeProvider theme={theme}>
        <Container
          maxWidth='true'
          sx={{
            pl: '2rem',
            pt: '2rem',
            height: window.innerHeight,
            overflowY: 'auto',
            backgroundColor: 'rgba(245,245,245,.6)',
          }}
        >
          {faqData.map((faqItem, index) => (
            <Accordion key={index}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${index + 1}-content`}
                id={`panel${index + 1}-header`}
                sx={{ backgroundColor: '#f5f5f5' }}
              >
                <Typography variant='h6'>{faqItem.question}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant='body1'>
                  <p key={faqItem.answer}>{faqItem.answer}</p>
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Container>
    </ThemeProvider>
  );
};
